// Externe Bibliotheken
import React, { Component } from 'react';
import { Link } from 'react-router';
import _ from 'lodash';

// Interne Module
import * as storage from '@/_helper/storage';
import { deactivateExtras } from '@/_helper/deactivateExtras';
import { checkIsAlreadyBooked } from '@/_helper/checkAccess';

// Komponenten
import Header from '@/comp/header/header';
import Footer from '@/comp/footer/Footer';

// Styles
import './index.scss';
import { Icon } from '@/comp/icon/icon.tsx';

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bookStates: '',
        };

        this.isAlreadyBooked = this.isAlreadyBooked.bind(this);
    }

    componentDidMount() {
        document.title = 'Erfolgreich ' + window.$documentTitle;
        let bookStates = JSON.parse(sessionStorage.getItem('bookStates'));
        if (!bookStates) {
            window.location.href = '#/';
            return false;
        }

        this.setState({
            bookStates: bookStates,
        });

        if (storage.get('bookingData') != null && storage.get('bookingData').data != null) {
            this.setState({
                data: storage.get('bookingData').data,
            });
        }

        let offers = '';
        if (bookStates.travelType === 'railAndFly') {
            offers = 'railAndFlyOffers';
        } else if (bookStates.travelType === 'excursion') {
            offers = 'excursionOffers';
        } else if (bookStates.travelType === 'transfer') {
            offers = 'transferOffers';
        }

        if (offers !== '') {
            storage.remove(offers);
        }

        // Revalidation : booking data
        if (window.$revalidateEnabled) {
            storage.set('refreshData', new Date().getTime());
        }

        deactivateExtras();
    }

    isAlreadyBooked(s) {
        const { data } = this.state;

        let checkArr = [];
        checkArr = checkIsAlreadyBooked();

        let returnString = false;
        if (data !== undefined) {
            _.forEach(checkArr, function (value) {
                if (value === 'excursion') {
                    return false;
                }
                if (value === s) {
                    returnString = true;
                }
            });
        }

        return returnString;
    }

    render() {
        const { bookStates } = this.state;

        let travelTypeTitle = '';
        if (bookStates.travelType !== undefined && window.$content.extras[bookStates.travelType]?.title !== undefined) {
            travelTypeTitle = window.$content.extras[bookStates.travelType].title;
        }

        let mapServiceText = {
            default: {
                order:
                    'Sie erhalten eine erweiterte Reisebestätigung/Rechnung mit den Daten der gebuchten Zusatzleistung (' +
                    travelTypeTitle +
                    ') per E-Mail.',
                payment:
                    'Der Betrag wird mit der ursprünglich bei Buchung geleisteten Zahlart von uns abgebucht. Sollten Sie Rechnung als Zahlungsmethode gewählt haben, bitten wir um umgehende Überweisung. Detaillierte Zahlungsinformationen dazu erhalten Sie mit Ihrer erweiterten Reisebestätigung/Rechnung.',
                documents: {
                    headline: 'Reiseunterlagen',
                    text:
                        'Nach Zahlungseingang erhalten Sie Ihre erweiterten Reiseunterlagen inklusive des Tickets für die Zusatzleistung ' +
                        travelTypeTitle +
                        ' per E-Mail.',
                },
            },
            railAndFly: {
                documents: {
                    text: 'Nach Zahlungseingang erhalten Sie Ihre erweiterten Reiseunterlagen inklusive der Einlösecodes für die Tickets der Zusatzleistung Zug zum Flug per E-Mail.',
                },
            },
            excursion: {
                order: 'Sie erhalten eine erweiterte Reisebestätigung/Rechnung mit den Daten des gebuchten Ausflugs per E-Mail.',
                documents: {
                    headline: 'Erweiterte Reiseunterlagen plus Voucher',
                    text: 'Nach Zahlungseingang erhalten Sie Ihre erweiterten Reiseunterlagen inklusive des Vouchers für den Ausflug per E-Mail.',
                },
            },
            seatReservation: {
                order: 'Sie erhalten eine erweiterte Reisebestätigung/Rechnung mit den Daten der gebuchten Sitzplätze per E-Mail.',
                documents: {
                    headline: 'Erweiterte Reiseunterlagen plus Sitzplatzreservierung',
                    text: 'Nach Zahlungseingang erhalten Sie Ihre erweiterten Reiseunterlagen inklusive des Vouchers für die Sitzplatzreservierung per E-Mail.',
                },
            },
        };

        const serviceBooked = () => {
            let text = [];

            switch (bookStates.travelType) {
                case 'seatReservation':
                    text.push(<>Ihre Sitzplatzreservierung(en) sind bei uns eingegangen.</>);
                    break;
                case 'excursion':
                    text.push(
                        <>
                            Ihre Buchung <br className="break" /> (Ausflug) ist bei uns eingegangen.
                        </>
                    );
                    break;
                default:
                    text.push(
                        <>
                            Ihre Buchung <br className="break" />
                            {bookStates.travelType && ' (' + travelTypeTitle + ') '} ist bei uns eingegangen.
                        </>
                    );
            }

            return (
                <>
                    {text.map((v, i) => (
                        <span key={i}>{v}</span>
                    ))}
                </>
            );
        };

        return (
            <div className="page-success">
                <Header />

                <div className="content-wrapper">
                    <div className="page-content">
                        {bookStates !== undefined && bookStates !== null && (
                            <div className="intro sec">
                                <div className="head">
                                    <div className="icon"></div>
                                    <div className="content">
                                        <h1 className="main-headline col">Vielen Dank!</h1>
                                        <p>
                                            Ihre Referenznummer: <br />
                                            <b>{bookStates.bookingId}</b>
                                        </p>
                                    </div>
                                </div>

                                <div className="service-booked">{serviceBooked()}</div>
                            </div>
                        )}

                        <div className="continuation sec">
                            <h3 className="heading">So geht es weiter</h3>
                            <div className="boxes  withrest">
                                <div className="first box">
                                    <div className="title">Bestätigung</div>
                                    <div className="icon"></div>
                                    <div className="action">
                                        {bookStates.travelType &&
                                        mapServiceText[bookStates.travelType]?.order !== undefined
                                            ? mapServiceText[bookStates.travelType].order
                                            : mapServiceText['default'].order}
                                    </div>
                                </div>
                                <div className="box">
                                    <div className="title">Zahlung</div>
                                    <div className="icon"></div>
                                    <div className="action">
                                        {bookStates.travelType &&
                                        mapServiceText[bookStates.travelType]?.payment !== undefined
                                            ? mapServiceText[bookStates.travelType].payment
                                            : mapServiceText['default'].payment}
                                    </div>
                                </div>
                                <div className="last box">
                                    <div className="title">
                                        {bookStates.travelType &&
                                        mapServiceText[bookStates.travelType]?.documents.headline !== undefined
                                            ? mapServiceText[bookStates.travelType].documents.headline
                                            : mapServiceText['default'].documents.headline}
                                    </div>
                                    <div className="icon"></div>
                                    <div className="action">
                                        {bookStates.travelType &&
                                        mapServiceText[bookStates.travelType]?.documents.text !== undefined
                                            ? mapServiceText[bookStates.travelType].documents.text
                                            : mapServiceText['default'].documents.text}
                                    </div>
                                </div>
                            </div>

                            <div className="flex contact">
                                <div>
                                    <span className="icon-phone"></span>
                                </div>
                                <div className="cnt">
                                    <p>
                                        Wenn Sie weitere Fragen haben, steht Ihnen unser Serviceteam gerne zur
                                        Verfügung!
                                    </p>
                                    <div>
                                        <a className="number" href="tel:+4989998299531">
                                            089 9982 99 531
                                        </a>
                                    </div>
                                    <div>
                                        <a className="mail" href="mailto:service@aurumtours.de">
                                            service@aurumtours.de
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="user-action">
                        <Link to={'/'} className="back-link">
                            <Icon name="keyboardArrowLeft" />
                            Zur Startseite
                        </Link>
                    </div>
                </div>

                <Footer />
            </div>
        );
    }
}

export default Index;
